/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import moment from 'moment';
import { Component } from 'react';
import ModalPopup from '../ModalPopup/ModalPopup';
import CalendarDatePeriod from './components/CalendarDatePeriod/CalendarDatePeriod';
import CalendarField from './components/CalendarField/CalendarField';
import { ACTIVE_DAY, ICalendarProps, ICalendarState } from './types';
import { LOCALES, LOCALES_DOUBLE } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { formatDate } from 'src/utils/helpers';
import ReactCalendar from 'src/view/components/ReactCalendar/ReactCalendar';
import { defaultDate } from '~/constants/dateTime';
import './style.scss';

export default class Calendar extends Component<ICalendarProps, ICalendarState> {
  static defaultProps = {
    type: 'past',
    //
    selectRange: true,
    minDate: new Date(2017, 0, 1),
    minDetail: 'decade',
  };

  state = {
    start_date: defaultDate,
    end_date: defaultDate,
    calendarModal: false,
    activeDay: ACTIVE_DAY.START,
  };

  modal: ModalPopup | null = null;
  firstDay: boolean = false;

  calendarModalOpen = () => {
    this.setState(
      {
        start_date: this.props.start_date ? formatDate(this.props.start_date) : defaultDate,
        end_date: this.props.end_date ? formatDate(this.props.end_date) : defaultDate,
        activeDay: ACTIVE_DAY.START,
        calendarModal: true,
      },
      this.modal?.openModalPopup
    );
  };

  calendarModalClose = () => {
    this.setState({ calendarModal: false });
  };

  changeDate = (data: [Date, Date] | [Date, undefined] | Date) => {
    if (!data) return;

    let startDate: Date | undefined = undefined;
    let endDate: Date | undefined = undefined;

    if (!Array.isArray(data)) {
      startDate = data;
    } else {
      [startDate, endDate] = [data[0], data[1]];
    }

    this.props.changeDate({ startDate, endDate });
    if (this.firstDay) {
      this.firstDay = false;
      return;
    }

    this.calendarModalClose();
  };

  clickDay = (date: Date) => {
    if (this.props.selectByDay) {
      if (this.state.activeDay === ACTIVE_DAY.START) {
        this.setState({ start_date: formatDate(date), end_date: defaultDate, activeDay: ACTIVE_DAY.END }, () => {
          this.firstDay = true;
          this.changeDate([date, undefined]);
        });
      } else {
        this.setState({ end_date: formatDate(date), activeDay: ACTIVE_DAY.START });
      }
    } else {
      if (this.state.activeDay === ACTIVE_DAY.START) {
        this.setState({ start_date: formatDate(date), activeDay: ACTIVE_DAY.END });
      } else {
        this.setState({ end_date: formatDate(date), activeDay: ACTIVE_DAY.START });
      }
    }
  };

  resetDate = () => {
    this.props.changeDate({ startDate: undefined, endDate: undefined });
  };

  render() {
    return (
      <ModalPopup
        autoClose={!this.props.disabledAutoClose}
        horizontal={this.props.horizontal}
        vertical={this.props.vertical}
        ref={(modal) => (this.modal = modal)}
        content={
          this.state.calendarModal ? (
            <div className="calendar__modal d-flex flex-column p-2">
              <CalendarDatePeriod {...this.props} {...this.state} />
              <ReactCalendar
                {...this.props}
                value={[moment(this.props.start_date).toDate(), moment(this.props.end_date).toDate()]}
                onChange={this.changeDate}
                onClickDay={this.clickDay}
                selectRange={this.props.selectRange}
                maxDate={this.props.type === 'future' ? undefined : new Date()}
                minDate={this.props.type === 'future' ? new Date() : this.props.minDate}
                minDetail={this.props.minDetail}
                maxDetail={this.props.maxDetail}
                locale={localeStore.language === LOCALES.EN ? LOCALES_DOUBLE.en : LOCALES_DOUBLE.ar}
                formatMonth={(locale, date) => moment(date).format('MMM')}
                formatShortWeekday={(locale, date) => moment(date).format('dd')}
                className={classNames('mt-4', this.props.className)}
              />
              {this.props.children}
              <button className="calendar__modal-overlay" onClick={this.calendarModalClose}></button>
            </div>
          ) : null
        }
      >
        <CalendarField calendarModalOpen={this.calendarModalOpen} resetDate={this.resetDate} {...this.props} />
      </ModalPopup>
    );
  }
}
